import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { orderDetailsAPI, warningsAPI, errorsAPI, tagsAPI } from 'src/app/services/apiRoutes';
import { NejoData } from '../models/nejo-data';
import { Observable } from 'rxjs';
import { AsyncDropdown } from 'src/app/models/async-dropdown';

@Injectable()
export class OrderService {
  constructor(public http: HttpClient) {}

  /* nejo data section */
  getNejoData(id: string): Promise<NejoData> {
    return this.http.get<NejoData>(orderDetailsAPI + '/' + id).toPromise();
  }

  getBoForDropdown(id: string): Promise<AsyncDropdown[]> {
    return this.http.get<NejoData>(orderDetailsAPI + '/' + id).toPromise().then(res => {
      if (res?.bo) {
        return res.bo.map(ele => ({ "identifier": ele, "code": ele, "name": ele }));
      }
      return [];
    });
  }

  updateNejoData(data: NejoData): Promise<NejoData> {
    return this.http.put<NejoData>(orderDetailsAPI + '/' + data.identifier, data).toPromise();
  }

  createOrder(data: NejoData): Promise<NejoData> {
    return this.http.post<NejoData>(orderDetailsAPI, data).toPromise();
  }

  deleteOrder(id: string) {
    return this.http.delete(orderDetailsAPI + '/' + id).toPromise();
  }

  getWarnings(id: string): Promise<Array<string>> {
    return this.http.get<Array<string>>(warningsAPI + '/' + id).toPromise();
  }

  getErrors(code: string): Promise<Array<string>> {
    return this.http.get<Array<string>>(errorsAPI + '/' + code).toPromise();
  }

  getTags(query: string): Observable<Array<string>> {
    return this.http.get<Array<string>>(tagsAPI + '/autocomplete?query=' + query);
  }

  /* nejo data section */
}
